import React from "react";

function ElectricIcon() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.75 0.75L0.75 12.75H9.75L8.75 20.75L18.75 8.75H9.75L10.75 0.75Z"
        stroke="#9333EA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ElectricIcon;
